import SolutionPage from './index';

export default function ELivingLabPage() {
  return <SolutionPage pageId="e-living-lab" />;
}
